import React from 'react';
import { Brain, Dumbbell, Users, Apple, BookOpen, Video } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const iconMap = {
  Brain: Brain,
  Dumbbell: Dumbbell,
  Users: Users,
  Apple: Apple,
  BookOpen: BookOpen,
  Video: Video
};

const About = () => {
  return (
    <section id="about" className="py-20 md:py-32 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 md:gap-16 items-center">
            {/* Image */}
            <div className="order-2 md:order-1">
              <div className="relative">
                <img
                  src="https://customer-assets.emergentagent.com/job_train-with-purpose/artifacts/ux9wrppu_20210509_064803000_iOS.jpg"
                  alt="Willis - Performance Mindset Coach"
                  className="rounded-2xl shadow-2xl w-full"
                  style={{ 
                    objectFit: 'contain',
                    objectPosition: 'center',
                    maxHeight: '700px',
                    height: 'auto'
                  }}
                />
                <div className="absolute -bottom-6 -right-6 bg-brand-orange text-white p-6 rounded-2xl shadow-xl">
                  <p className="text-3xl font-bold">10+</p>
                  <p className="text-sm font-medium">Years Experience</p>
                </div>
              </div>
            </div>

            {/* Content */}
            <div className="order-1 md:order-2">
              <h2 className="text-3xl md:text-5xl font-bold text-brand-black mb-6 leading-tight">
                Meet Your Coach – Willis
              </h2>
              <div className="space-y-4 text-brand-gray text-lg leading-relaxed">
                <p>
                  I help people build strength from the inside out — physically, mentally, and consistently.
                </p>
                <p>
                  Through personal training, mindset coaching, youth athletic development, and nutrition support, I guide clients toward results that last.
                </p>
                <p className="font-semibold text-brand-black">
                  No fluff. No gimmicks. Just structure, support, and steady progress.
                </p>
              </div>
              
              <div className="mt-8 p-6 bg-brand-light-gray rounded-2xl">
                <p className="text-xl md:text-2xl font-bold text-brand-black leading-tight">
                  Train the Mind. Move the Body. Lead with Confidence.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;